


















import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { TalentAgent } from "@scrile/api-provider/dist/api/TalentAgentsProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import { resolveUserName } from "@/lib/userHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import ListItem from "@/components/ListItem";

export default defineComponent({
  name: "CreatorByTalentRepItem",
  components: { BaseAvatar, ListItem },
  props: {
    data: { type: Object as () => TalentAgent, required: true },
  },
  methods: { resolveUserName },
  computed: {
    profileUrl(): Location | null {
      return this.data.user ? getProfileUrl(this.data.user) : null;
    },
  },
});
